// extracted by mini-css-extract-plugin
export default {"captcha":"XuttVg","bis":"ivHfpT","imgBis":"BHr6_x","resetBis":"SP77g9","inputBis":"iSe5qb","reset":"YTq4ld"};